export var getTimezoneValue = function getTimezoneValue(_ref) {
  var timezone = _ref.timezone,
      timezones = _ref.timezones,
      isLoading = _ref.isLoading,
      defaultTimezone = _ref.defaultTimezone;
  if (typeof timezone === 'string') return timezone;
  if (isLoading) return null;

  if (typeof timezone === 'number') {
    var namedTimezone = timezones.find(function (_ref2) {
      var numberOfSecondsToOffsetTime = _ref2.numberOfSecondsToOffsetTime;
      return numberOfSecondsToOffsetTime === timezone;
    });

    if (namedTimezone) {
      var name = namedTimezone.name;
      return name;
    }
  }

  return defaultTimezone;
};